import Azure from "./assets/navigator/azure.png";
import Copilot from "./assets/navigator/copilot.jpg";
import Cyber from "./assets/navigator/cybersecurity.jpg";
import Data from "./assets/navigator/data.jpg";
import Dev from "./assets/navigator/dev.png";
import Ethics from "./assets/navigator/ethics.jpg";
import Fluency from "./assets/navigator/fluency.png";
import Passport from "./assets/navigator/passport.jpg";
import Productivity from "./assets/navigator/productivity.jpg";
import Photo1 from "./assets/navigator/photo1.png";
import Photo2 from "./assets/navigator/photo2.png";
import Photo3 from "./assets/navigator/photo3.jpg";

export const ByTopic = [
  {
    tag: "Generative AI Productivity",
    title: "AI Skills Passport",
    desc: "Learn how to futureproof your career with AI",
    photo: Passport,
  },
  {
    tag: "Generative AI Basics",
    title: "Career Essentials in Generative AI",
    desc: "Learn essential skills in generative AI, brought to you by Microsoft and LinkedIn",
    photo: Fluency,
  },
  {
    tag: "Generative AI Ethics",
    title: "Generative AI and Ethics",
    desc: "Explore the ethical implications of generative AI and understand the urgency of addressing these challenges.",
    photo: Ethics,
  },
  {
    tag: "Generative AI Productivity",
    title: "Build Your Generative AI Productivity Skills",
    desc: "Enhance your productivity skills with generative AI, provided by Microsoft and LinkedIn.",
    photo: Productivity,
  },
  {
    tag: "Cybersecurity",
    title: "Career Essentials in Cybersecurity",
    desc: "Discover the skills needed for a career in cybersecurity.",
    photo: Cyber,
  },
  {
    tag: "Data Analytics",
    title: "Career Essentials in Data Analysis by Microsoft and LinkedIn",
    desc: "Explore the ethical implications of generative AI and understand the urgency of addressing these challenges.",
    photo: Data,
  },
  {
    tag: "AI Tools and Applications",
    title: "Microsoft Azure AI Fundamentals",
    desc: "Artificial Intelligence (AI) empowers amazing new solutions and experiences; and Microsoft Azure provides easy to use services to help you get started.",
    photo: Azure,
  },
  {
    tag: "Github Copilot",
    title: "Accelerate app development by using Github Copilot",
    desc: "Learn how Github Copilot can help you write code faster and more efficiently.",
    photo: Copilot,
  },
];

export const ByRole = [
  {
    tag: "Organization Leader",
    title: "AI for Managers by Microsoft and LinkedIn",
    desc: "Managers at all levels of the organization will lean practical ways to enhance their effectiveness with generative AI.",
    photo: Photo1,
  },
  {
    tag: "Organization Leader",
    title: "AI for Organizational Leaders",
    desc: "Equip yourself with AI knowledge to lead your organization into the future.",
    photo: Photo2,
  },
  {
    tag: "Everyone",
    title: "Micorosoft Copilot for Productivity",
    desc: "Improve your productivity with Microsoft Copilot, designed to assist you in everyday tasks.",
    photo: Photo3,
  },
  {
    tag: "Trainer",
    title: "Intro to Generative AI for Trainers",
    desc: "Equip yourself with the knowledge to train others in generative AI.",
    photo: Data,
  },
  {
    tag: "Public Sector Employees",
    title: "AI in the Public Sector",
    desc: "Explore and start imagining how AI can help your public sector organization.",
    photo: Dev,
  },
  {
    tag: "Educators",
    title: "MSFT Educator academy",
    desc: "Explore microsoft resources for educators and other school staff.",
    photo: Azure,
  },
  {
    tag: "Developer",
    title: "Create Copilots with Microsoft Copilot Studio",
    desc: "Develop your own copilots using the Microsoft Copilot Studio tools.",
    photo: Copilot,
  },
  {
    tag: "Organization Leader",
    title: "Tranform Your Business with Microsoft AI",
    desc: "Learn how to leverage AI to transform and grow your business.",
    photo: Ethics,
  },
];
